import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export interface TokenUsageSummary {
  totalSessions: number;
  uniqueUsers: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
  totalTurns: number;
  avgTokensPerSession: number;
  avgTokensPerTurn: number;
  maxTokensInSession: number;
}

export interface SessionTokenRow {
  sessionId: string;
  userId: string;
  title: string | null;
  studyIds: string[];
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  turnCount: number;
  totalCacheReadTokens: number;
  totalCacheWriteTokens: number;
  modelCallCount: number;
  toolCallCount: number;
  totalToolDurationMs: number;
  agents: string[];
  tools: string[];
  createdAt: string | null;
  updatedAt: string | null;
}

export interface ToolTokenRow {
  toolName: string;
  sessionCount: number;
  callCount: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
  avgTokensPerCall: number;
  avgDurationMs: number;
}

export interface UserTokenRow {
  userId: string;
  userName: string | null;
  userEmail: string | null;
  sessionCount: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
  totalTurns: number;
  avgTokensPerSession: number;
  isInternal: boolean;
}

export interface StudyTokenRow {
  studyId: string;
  studyName: string | null;
  sessionCount: number;
  totalTokens: number;
  totalTurns: number;
  uniqueUsers: number;
}

export interface AgentTokenRow {
  agentName: string;
  sessionCount: number;
  callCount: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
  totalCacheReadTokens: number;
  totalCacheWriteTokens: number;
}

export interface DailyTokenRow {
  date: string;
  sessionCount: number;
  totalTokens: number;
  totalTurns: number;
  uniqueUsers: number;
}

export interface ModelTokenRow {
  model: string;
  modelId: string;
  provider: string;
  sessionCount: number;
  callCount: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  totalTokens: number;
  totalCacheReadTokens: number;
  totalCacheWriteTokens: number;
  estimatedCostUsd: number;
}

export interface TokenUsageOverview {
  summary: TokenUsageSummary;
  topSessions: SessionTokenRow[];
  byTool: ToolTokenRow[];
  byUser: UserTokenRow[];
  byStudy: StudyTokenRow[];
  byAgent: AgentTokenRow[];
  byModel: ModelTokenRow[];
  dailyTrend: DailyTokenRow[];
}

export const getTokenUsageOverview = (days = 30, limit = 50) => {
  return apiRequestHandlerPromise<TokenUsageOverview>({
    url: `admin/copilot/token-usage?days=${days}&limit=${limit}`,
    method: 'GET',
  });
};
